import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import TableList from "../../Components/tableList/TableList";
import Api from "../../services/api";
import "../Prelude/prelude.css";
import "../../Components/reports/reports.css";
import InputReport from "../../Components/inputReport/inputReport";
import "../../Components/inputReport/inputReport.css";
import DatePicker from "../../Components/datePicker/datePicker";
import MessageTable from "../../Components/messageTable/MessageTable";
import moment from "moment";
import ExcelButton from "../../Components/exportExcelButton/ExportExcelButton";
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import "./generalReports.css";
import Button from '../../Components/commonButton/commonButton';
import FilterBox from "../../Components/filterBox/filterBox";


class ReportOEE extends React.Component {
  state = {
    text: "",
    resp: "",
    data: [],
    initialData: [],
    render: false,
    arrayWorkShifts: [],
    arr_idcodes: [],
    start_date: new Date().toLocaleDateString('pt-BR'),
    end_date: new Date().toLocaleDateString('pt-BR'),
    machine: "",
    item: "",
    loading: false,
  };
  
  sendData = async () => {
    const params = {
      machine: this.state.machine.trim(),
      item: this.state.item.trim(),
      dt_ini: this.state.start_date,
      dt_end: this.state.end_date
    }

    let count = 0
    for (let p in params) {
      if (params[p])
        count++
    }
    if (count > 0) {
      this.setState({ loading: true })
      await Api.get("/reports/oee", { params: params })
        .then((resp) => {
          let arr = [];
          let aux = "";
          if (resp.data.length === 0) {
            this.setState({ render: false });
          } else {
            console.log(resp.data)
            resp.data.forEach((elementReport) => {
              if(elementReport.Unidade === "m"){
                aux = elementReport.produced + "m";
              } else if(elementReport.Unidade === "pcs"){
                aux = elementReport.produced + "pcs";
              } else if (elementReport.Unidade === "m2"){
                aux = elementReport.produced + "m2";
              } else if (elementReport.Unidade === "g"){
                aux = elementReport.produced + "g";
              }else{
                aux = elementReport.produced;
              }
              
              arr.push({
                ["Seq."]:elementReport["Seq"],
                Máquina: elementReport["Máquina"],
                Ordem: elementReport.Ordem,
                Item: elementReport.Item,
                Operador: elementReport.Operador,
                Data: moment(elementReport.Data).format("DD/MM/YYYY"),
                ["Data final"]: moment(elementReport["Data final"]).format("DD/MM/YYYY"),
                Início: elementReport.Inicio,
                Fim: elementReport.Fim,
                Tempo: elementReport.Tempo,
                ["Previsto"]: elementReport.planned_time,
                ["Parado"]: elementReport.loss_time,
                Produzido: elementReport.produced == 0 ? 0 : aux,
                Refugo: elementReport.refuse_amount == 0 ? 0 : `${elementReport.refuse_amount}${elementReport.Unidade}`,
                FTQ: elementReport.ftq,
                OEE: elementReport["OEE"] + "%",
                ["Disponibilidade"]: elementReport["Disponibilidade"] + "%",
                ["Performance"]: elementReport["Performance"] + "%",
                ["Qualidade"]: elementReport["Qualidade"] + "%",
                Turno: elementReport.shift
              });
            });
            this.setState({ data: arr, render: true, initialData: arr });
            if (this.state.loading) this.setState({ loading: false });
          }
        })
        .catch((err) => {
          alert("Erro de conexão com o servidor");
        });

      await Api.get("/work-shifts/")
        .then((resp) => {
          let arr_codes = [];
          let arr_ids = [];
          resp.data.forEach((elementReport) => {
            arr_codes.push({ value: elementReport.code });
            arr_ids.push({ id: elementReport.id, code: elementReport.code });
          });
          this.setState({ arrayWorkShifts: arr_codes, arr_idcodes: arr_ids });
          if (this.state.loading) this.setState({ loading: false });
        })
        .catch((error) => {
          if (error.response) {
            return alert(
              error.response.data +
              "\n" +
              error.response.status +
              "\n" +
              error.response.headers
            );
          }
        });
    } else {
      alert("Preencha um campo de filtro");
    }
  }

  excelbutton = (event) =>{
    if(this.state.data.length === 0){
        alert("Preencha um campo de filtro")
        event.preventDefault()
    }
       
   }

  saveText = (data) => {
    const { value, name } = data;
    this.setState({ [`${name}`]: value });
    /* this.filter(value, name); */
  };

  filterData = (data, name) => {
    /* if (this.state[`${name}`].name === name) {
      let dateFilterCamp = this.state[`${name}`];
      dateFilterCamp.value = data; */
    this.setState({ [`${name}`]: data });
    /* } */

    /* const { initialData, start_date, end_date, Item } = this.state;
    if (data.length < 10) {
      this.setState({ data: initialData });
    } else {
      let result = this.state.data.filter((value) => {
        return (
          value["Data"] >= start_date.value && value["Data"] <= end_date.value
        );
      });
      if (result.length > 0) {
        this.setState({ data: result });
      } else {
        this.setState({ data: initialData });
      }
    } */
  };

  render() {

  
    return (
      < >
          <div className="filters boxReport">
            <FilterBox title="Filtros">
            <div className="elementFilter" type="input">
                  {" "}
                  <InputReport
                    name="machine"
                    parentCallback={this.saveText}
                    title="Máquina"
                    focus={true}
                  />{" "}
                </div>
                <div className="elementFilter" type="input">
                  {" "}
                  <InputReport
                    name="item"
                    parentCallback={this.saveText}
                    title="Item"
                  />{" "}
                </div>
                <div className="elementFilter" type="input">
                  <DatePicker
                    name="Data"
                    title="Data Inicial"
                    parentCallback={(e) => this.filterData(e, "start_date")}
                  ></DatePicker>
                </div>
                <div className="elementFilter" type="input">
                  <DatePicker
                    name="Data"
                    title="Data Final"
                    parentCallback={(e) => this.filterData(e, "end_date")}
                  ></DatePicker>
                </div>

                <div className="buttonFilter" type="button">
                    <ExcelButton onClick={this.excelbutton}
                      data={this.state.data}
                      filename={`oee_${moment()
                        .utc()
                        .utcOffset("-03:00")
                        .format("DDMMYY_HHmmss")}.csv`}
                    />
                  </div>
                  <div className="buttonFilter" type="button">
                    <Button size title="Gerar" icon="faGear" parentCallback={this.sendData} />
                  </div>

            </FilterBox>

            {this.state.loading ? (
              <div className="TableReport">
                <div style={{ marginTop: '20vh' }} className={styles.loader}>
                  <Spinner variant="success" animation="border" />
                  <strong>Carregando...</strong>
                </div>
              </div>
            ) : (
              <div className="TableReport">
                {this.state.render ? (
                  <TableList data={this.state.data}>
                    
                  </TableList>
                ) : (
                  <div>
                    <MessageTable message={"Sem dados para processar."} />
                  </div>
                )}
              </div>
            )}
          </div>
      </>
    );
  }
}

export default ReportOEE;